import React, { FC } from "react";
import { Typography } from "@mui/material";
import { Image } from "cloudinary-react";
import ReusableAccordian from "../../ReusableAccordion";
import Choices from "../../Choices";
import { SliderScreenOption } from "../SliderScreen/defaults";
import { RowLayout, ColLayout } from "../../../util/accordianStyles";
import useScreenPocketSelector from "./useScreenPocketSelector";

interface SliderScreenPocketProps {
  screenOptions: SliderScreenOption | undefined;
  isPocketing: boolean;
}

const SliderScreenPocketAccordian: FC<SliderScreenPocketProps> = ({
  screenOptions,
  isPocketing,
}) => {
  const {
    pocketLabel,
    filteredPocketImg,
    handleClick,
    pocketToShow,
    chosenConfig,
    displayedPocketImg,
  } = useScreenPocketSelector(screenOptions, isPocketing);

  return (
    <ReusableAccordian
      accordionName="screenPocket"
      heading="Screen Pocket"
      secondaryHeading="Add a screen pocket?"
      colOrRow="col"
    >
      <ColLayout style={{ marginLeft: 40 }}>
        <Typography variant="caption">
          *upcharge applies for each pocket added
        </Typography>

        {chosenConfig.includes("O") &&
        (displayedPocketImg === "Double Screen Right Pocket" ||
          displayedPocketImg === "Double Screen Left Pocket") ? (
          <Typography variant="caption">
            **Screen Pocket is required with this configuration to avoid
            blocking handle hardware
          </Typography>
        ) : null}
        <RowLayout>
          {pocketToShow?.map((state) => (
            <div
              key={state.id}
              onClick={() => handleClick(state.label, state.disabled || false)}
            >
              <Choices
                label={state.label}
                variant={state.label === pocketLabel ? "filled" : "outlined"}
                checkMark={state.label === pocketLabel}
                disabled={state.disabled || false}
                wide={true}
              />
            </div>
          ))}
        </RowLayout>
      </ColLayout>

      <RowLayout>
        {displayedPocketImg && filteredPocketImg?.label && (
          <RowLayout>
            <ColLayout style={{ marginRight: 20 }}>
              <Image
                secure="true"
                cloudName="ag-millworks"
                publicId={filteredPocketImg.publicId}
              />
              <Typography variant="caption">*As viewed from above</Typography>
            </ColLayout>

            <ColLayout style={{ marginLeft: 20 }}>
              <img src={filteredPocketImg.img2} alt="pocket2" />
              <Typography variant="caption">
                *As viewed from exterior
              </Typography>
            </ColLayout>
          </RowLayout>
        )}
      </RowLayout>
    </ReusableAccordian>
  );
};

export default SliderScreenPocketAccordian;
